import { createStore, combineReducers, applyMiddleware } from 'redux';
import { reducer as formReducer } from 'redux-form';
import ReduxThunk from 'redux-thunk';

const user  = localStorage.getItem('user');
const token = localStorage.getItem('token');
const initialState = user && token ? { user: JSON.parse(user), status: false, token: token } : null;
const initialStatNotificationse = { list: [] };

const Alert = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'ALERT_SHOW':
      newState = action.data;
      return newState;
    case 'ALERT_HIDE':
      newState = action.data;
      return newState;
    default:
      return state;
  }

}

const Notifications = (state = initialStatNotificationse, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'NOTIFICATIONS_UPDATE':
      newState = action.data;
      return newState;
    case 'NOTIFICATIONS_ADD':
      newState = action.data;
      return newState;
    case 'NOTIFICATIONS_CLEAR':
      newState = action.data;
      return newState;
    default:
      return state;
  }

}

const User = (state = initialState, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'USER_SET':
      newState = action.data;
      return newState;
    case 'USER_REMOVE':
      newState = null;
      return newState;
    default:
      return state;
  }

}

const UserUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'USER_UPDATE':
      newState = action.data.user;
      return newState;
    case 'USER_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const PageUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'PAGE_UPDATE':
      newState = action.data;
      return newState;
    case 'PAGE_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const ComponentsUpdate = (state = {}, action) => {

  //let newState = Object.assign({}, state);
  let newState = state;

  switch(action.type){
    case 'COMPONENT_UPDATE':
      newState = action.data;
      return newState;
    case 'COMPONENT_DELETE':
      let index = newState.findIndex(c => c._id === action.data);
      if(index){
        newState.splice(index, 1);
      }
      return newState;
    case 'COMPONENT_UPDATE_CLEAR':
      newState = [];
      return newState;
    default:
      return state;
  }

}

const ProductUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'PRODUCT_UPDATE':
      newState = action.data.product;
      return newState;
    case 'PRODUCT_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const PlanUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'PLAN_UPDATE':
      newState = action.data.plan;
      return newState;
    case 'PLAN_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const FeaturedUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'FEATURED_UPDATE':
      newState = action.data.featured;
      return newState;
    case 'FEATURED_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const BannerUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'BANNER_UPDATE':
      newState = action.data.banner;
      return newState;
    case 'BANNER_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const BlogUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'BLOG_UPDATE':
      newState = action.data.note;
      return newState;
    case 'BLOG_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const AlertUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'ALERT_UPDATE':
      newState = action.data.alert;
      return newState;
    case 'ALERT_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const AttachmentUpload = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'ATTACHMENT_UPLOAD_SHOW':
      newState = action.data;
      return newState;
    case 'ATTACHMENT_UPLOAD_HIDE':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const AutogestionUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'AUTOGESTION_UPDATE':
      newState = action.data.autogestion;
      return newState;
    case 'AUTOGESTION_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const PollUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'POLL_UPDATE':
      newState = action.data.poll;
      return newState;
    case 'POLL_UPDATE_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const PageContentUpdate = (state = {}, action) => {

  let newState = Object.assign({}, state);

  switch(action.type){
    case 'PAGE_CONTENT_UPDATE':
      newState = action.data.page;
      return newState;
    case 'PAGE_CONTENT_CLEAR':
      newState = {};
      return newState;
    default:
      return state;
  }

}

const reducers = combineReducers({
  Alert: Alert,
  User: User,
  UserUpdate: UserUpdate,
  PageUpdate: PageUpdate,
  ComponentsUpdate: ComponentsUpdate,
  ProductUpdate: ProductUpdate,
  PlanUpdate: PlanUpdate,
  FeaturedUpdate: FeaturedUpdate,
  BannerUpdate: BannerUpdate,
  BlogUpdate: BlogUpdate,
  AlertUpdate: AlertUpdate,
  AttachmentUpload: AttachmentUpload,
  AutogestionUpdate: AutogestionUpdate,
  PollUpdate: PollUpdate,
  Notifications: Notifications,
  PageContentUpdate: PageContentUpdate,

  form: formReducer
});

const store = createStore(reducers, applyMiddleware(ReduxThunk));

export default store;
